const TopicTagsRouteNavigationOptions = {
  title: 'Tags',
  headerTitle: 'Tags',
  headerBackVisible: false,
};

export default TopicTagsRouteNavigationOptions;
